import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {CloseIcon} from "../../../assets/icons";
import {addTextToCanvas} from "../../../utils/helpers";
import {HeadingText} from "../../../Components/StyledComponents";
import {ExampleText} from "../../../utils/constants";

const ScripturePrayersPanel = ({setToggleSubMenu}) => {
    const {canvas} = useSelector((state) => state.canvas);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);

    const closeTextPanel = () => {
        setToggleSubMenu(false)
    }
    const searchAndFilter = (e) => {
        setSearchQuery(e.target.value);
    };
    return (
        <div className="text-panel-wrapper">
            <div className='text-header'>
                <span className="heading-text">Scripture & prayers</span>
                <span onClick={closeTextPanel} className='cross-icon'><CloseIcon/></span>
            </div>
            <HeadingText>Text pre selected</HeadingText>
            <div className="search-section-inner">
                <input
                    type="search"
                    name=""
                    id=""
                    placeholder="Search all scriptures & prayers"
                    className="search-bar"
                    onChange={searchAndFilter}
                />
            </div>
            <div className='example-text-wrapper'>
                <div className='add-example-text-btn example-text-header'>
                    <span className="palm-text">Psalm 23</span>
                </div>
                {
                    ExampleText.filter((text) => text.text.toLowerCase().includes(searchQuery.toLowerCase())).map((text, key) => {
                        return (
                            <div key={text.text} className='add-example-text-btn'
                                 onClick={() => addTextToCanvas(text.text, 30, 'example_text', canvas)}>
                                <span>{text.text}</span>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    );
};

export default ScripturePrayersPanel;